import { Button } from '../../../modules/design-system';

export interface CancelDeliveryButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * "Cancel Delivery" CTA under the Show page cards — rendered only while the
 * backend reports the delivery as cancelable (`isAllowToCancel`). Stock DS
 * glass button with a destructive text colour themable via
 * `--co-CancelDeliveryButton-textColor`.
 */
export function CancelDeliveryButton({ onClick, disabled = false }: CancelDeliveryButtonProps) {
  return (
    <Button
      variant="glass"
      size="lg"
      onClick={onClick}
      disabled={disabled}
      fullWidth
      style={{ color: 'var(--co-CancelDeliveryButton-textColor, #F87171)' }}
    >
      Cancel Delivery
    </Button>
  );
}
